<template>
  <Copy :content="value" />
</template>

<script>
export default {
  name: "ControlApolloGridCopyEditor",
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
};
</script>
